import OPT from 'options'

export default {
  development: {
    // GRAPH_PRIVATE: 'https://a192c74afcc5.ngrok.io/graphql',
    // GRAPH_PUBLIC: 'https://a192c74afcc5.ngrok.io/public/graphql',
    // GRAPH_PRIVATE_WS: 'ws://192.168.1.38:8111/subscriptions',
    WEB_SERVER: `http://localhost:${OPT.port}`,
    WEB_CMS_SERVER: `http://localhost:${OPT.port}`,
    // API_HOST: 'http://192.168.1.6:8001',
    // FILE_SERVER: 'https://861683e827b4.ngrok.io',
    // GRAPH_PRIVATE: 'http:///localhost:8200/graphql',
    // GRAPH_PUBLIC: 'http:///localhost:8200/public/graphql',
    // FILE_SERVER: 'http://localhost:8200',
    GRAPH_PRIVATE: process.env.REACT_APP_GRAPH_PRIVATE,
    GRAPH_PUBLIC: process.env.REACT_APP_GRAPH_PUBLIC,
    // WEB_SERVER: process.env.REACT_APP_WEB_SERVER,
    // WEB_CMS_SERVER: process.env.REACT_APP_WEB_CMS_SERVER,
    API_HOST: process.env.REACT_APP_API_HOST,
    FILE_SERVER: process.env.REACT_APP_FILE_SERVER,
  },
  staging: {
    GRAPH_PRIVATE: process.env.REACT_APP_GRAPH_PRIVATE,
    GRAPH_PUBLIC: process.env.REACT_APP_GRAPH_PUBLIC,
    WEB_SERVER: process.env.REACT_APP_WEB_SERVER,
    WEB_CMS_SERVER: process.env.REACT_APP_WEB_CMS_SERVER,
    API_HOST: process.env.REACT_APP_API_HOST,
    FILE_SERVER: process.env.REACT_APP_FILE_SERVER,
  },
  production: {
    GRAPH_PRIVATE: process.env.REACT_APP_GRAPH_PRIVATE,
    GRAPH_PUBLIC: process.env.REACT_APP_GRAPH_PUBLIC,
    WEB_SERVER: process.env.REACT_APP_WEB_SERVER,
    WEB_CMS_SERVER: process.env.REACT_APP_WEB_CMS_SERVER,
    API_HOST: process.env.REACT_APP_API_HOST,
    FILE_SERVER: process.env.REACT_APP_FILE_SERVER,
  },
}

// 6: Note, 12: Fluke, 23: Tee
